import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { fetchWrapper } from '_helpers';
import { alertActions } from './alert.slice';

// create slice

const name = 'vehicles';
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, reducers, extraReducers });

// exports

export const vehicleActions = { ...slice.actions, ...extraActions };
export const vehiclesReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        list: null,
        item: null,
        selectedVehicleDetails: {
            warnings: null,
            lastPosition: null,
            isLoading: false,
            error: null,
            autorefresh: false
        },
        isLoading: false,
        showAllGeoloc: true,
    }
}

function createReducers() {
    return {
        setVehicles,
        setVehicle,
        toggleAutoRefresh,
        toogleShowAllVehicles,
        setShowAllVehicles,
        clearData,
    };

    function setVehicles(state, action) {
        state.list = action.payload;
    }

    function setVehicle(state, action) {
        state.item = action.payload;
    }

    function toggleAutoRefresh(state, action) {
        state.selectedVehicleDetails.autoRefresh = action.payload;
    }

    function toogleShowAllVehicles(state) {
        state.showAllGeoloc = !state.showAllGeoloc;
    }

    function setShowAllVehicles(state, action) {
        state.showAllGeoloc = action.payload;
    }

    function clearData(state, action) {
        state.selectedVehicleDetails = {
            warnings: null,
            lastPosition: null,
            isLoading: false,
            error: null,
            autorefresh: false
        };

        state.data = {
            events: [],
        };
        state.initialData = {
            events: [],
        };
    }
}

function createExtraActions() {
    const baseUrl = process.env.REACT_APP_API_URL;

    return {
        getAll: getAll(),  
        getVehicleWarnings: getVehicleWarnings(),
        getVehicleLastPositions: getVehicleLastPositions()
    };

    function getAll() {
        return createAsyncThunk(
            `${name}/get_vins`,
            async () => await fetchWrapper.get(`${process.env.REACT_APP_API_URL}/get_vins`)
        );
    }    

    function getVehicleWarnings() {
        return createAsyncThunk(
            `${name}/getVehicleWarnings`,
           async (vin, { dispatch }) => {
                try{
                    const warnings = await fetchWrapper.get(`${baseUrl}/voyants?vin=${vin}`);
                    dispatch(alertActions.success({message: 'Actualisation des Voyants', showAfterRedirect: true}))
                    return warnings;
                }
                catch (error) {
                    dispatch(alertActions.error({message: error ?? "Erreur lors de l'acualisation des voyants", showAfterRedirect: true}));
                }                
            }
        );
    }

    function getVehicleLastPositions() {
        return createAsyncThunk(
            `${name}/getVehicleLastPositions`,
            async (vin, { dispatch }) => {
                try{
                    const lastPosition = await fetchWrapper.get(`${baseUrl}/last_positions?vin=${vin}`);
                    dispatch(alertActions.success({message: 'Actualisation des positions GPS', showAfterRedirect: true}))
                    return lastPosition;
                }
                catch (error) {
                    dispatch(alertActions.error({message: error ?? "Erreur lors de l'acualisation des positions", showAfterRedirect: true}));
                }                
            }
        );
    }
}

function createExtraReducers() {
    return (builder) => {
        getAll();
        getVehicleLastPositions();
        getVehicleWarnings();
                

        function getAll() {
            var { pending, fulfilled, rejected } = extraActions.getAll;
            builder
                .addCase(pending, (state) => {
                    state.list = { loading: true };
                    state.isLoading = true;
                })
                .addCase(fulfilled, (state, action) => {
                    state.list = { value: action.payload };
                    state.isLoading = false;
                })
                .addCase(rejected, (state, action) => {
                    state.list = { error: action.error };
                    state.isLoading = false;
                });
        }

        /* Gestion regroupée pour les détails de bus étant donnée que ce sont 2 api différentes qui sont appelée
        Ce système permet de mettre en évidence une erreur sur un des deux appels */
        function handleDetailsPending(state) {
            state.selectedVehicleDetails.pendingCount = (state.selectedVehicleDetails.pendingCount || 0) + 1;
            state.selectedVehicleDetails.isLoading = true;
        }
        function handleDetailsFulfilled(state, action, field = 'data') {
            state.selectedVehicleDetails.pendingCount = (state.selectedVehicleDetails.pendingCount || 0) - 1;
            state.selectedVehicleDetails[field] = action.payload;
            if (state.selectedVehicleDetails.pendingCount === 0) {
                state.selectedVehicleDetails.isLoading = false;
            }
        }
        function handleDetailsRejected(state, action) {
            state.selectedVehicleDetails.pendingCount = (state.selectedVehicleDetails.pendingCount || 0) - 1;
            state.selectedVehicleDetails.error = action.error.message || 'Echec de récupération des données';
            if (state.selectedVehicleDetails.pendingCount === 0) {
                state.selectedVehicleDetails.isLoading = false;
            }
        }
        /* Fin gestion regroupée */

        function getVehicleLastPositions() {
            var { pending, fulfilled, rejected } = extraActions.getVehicleLastPositions;
            builder
                .addCase(pending, handleDetailsPending)
                .addCase(fulfilled, (state, action) => handleDetailsFulfilled(state, action, 'lastPosition', true))
                .addCase(rejected, handleDetailsRejected);
        }

        function getVehicleWarnings() {
            var { pending, fulfilled, rejected } = extraActions.getVehicleWarnings;
            builder
                .addCase(pending, handleDetailsPending)
                .addCase(fulfilled, (state, action) => handleDetailsFulfilled(state, action, 'warnings', true))
                .addCase(rejected, handleDetailsRejected);
        }
    }
}
